/**
 * The possible activity types can be reported with reportActivity API
 */
export const BIANKA_ACTIVITY_TYPES = {
    CLICK: 'click',
    HOVER: 'hover',
    PAGE_VIEW: 'page_view',
    IMPRESSION: 'impression'
};
